import "./Twist.css";

const Twist = () => (
  <div class="twist">
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
    <div class="oval"></div>
  </div>
);

export default Twist;
